import parseStorageHtml from 'src/components/PageBuilder/utils/parseStorageHtml';

export type PromotionsOverride = {
    title?: string;
    description?: string;
};

export function parsePromotionsOverrideCmsBlock(cmsBlock?: string): PromotionsOverride {
    if (!cmsBlock) {
        return {};
    }

    const parsedHtml = parseStorageHtml(cmsBlock);
    const row = parsedHtml?.children?.find((item) => item.contentType === 'row');

    const headingElement = row?.children?.find?.((item) => item?.contentType === 'heading');
    const descriptionElement = row?.children?.find?.((item) => item?.contentType === 'text');

    // Type error fix for Pagebuilder not listing text as an available property.
    const title = (headingElement as any)?.text ?? undefined;

    // Type error fix for Pagebuilder not listing text as an available property.
    const description = (descriptionElement as any)?.content ?? undefined;

    return { title, description };
}
